<template>
  <div class="card-text grid-field-url">
    <img
      v-if="faviconUrl"
      class="grid-field-url__favicon"
      :src="faviconUrl"
      alt=""
      loading="lazy"
      referrerpolicy="no-referrer"
      @error="faviconError = true"
    />
    <a
      :href="getHref(value)"
      target="_blank"
      rel="nofollow noopener noreferrer"
      class="forced-pointer-events-auto grid-field-url__text"
      @mousedown.stop
      >{{ value }}</a
    >
  </div>
</template>

<script>
import {
  ensureUrlProtocol,
  getFaviconUrl,
} from '@baserow/modules/core/utils/url'

export default {
  name: 'RowCardFieldURL',
  height: 16,
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      faviconError: false,
    }
  },
  computed: {
    faviconUrl() {
      if (this.faviconError) return null
      return getFaviconUrl(this.value)
    },
  },
  watch: {
    value() {
      this.faviconError = false
    },
  },
  methods: {
    getHref(value) {
      return value ? ensureUrlProtocol(value) : undefined
    },
  },
}
</script>
